import { appDomain } from "../domain/domain";
import { dependencies } from "../domain/dependencies";
import { PortResolver } from "@nx/typescript-domain";
import { CalendarService } from "../domain/calendars/CalendarService";
import { ICalendarRepository } from "../domain/calendars/ICalendarRepository";
import { CalendarRepository } from "../adapters/localdb/CalendarRepository";
import { ICalendarService } from "../domain/calendars/ICalendarService";
import { ILogService } from "../domain/log/ILogService";
import { LogService } from "../domain/log/LogService";
import { ConfigService } from "../domain/config/ConfigService";
import { IConfigService } from "../domain/config/IConfigService";
import { CardService } from "../domain/cards/CardService";
import { ICardService } from "../domain/cards/ICardService";
import { CardRepository } from "../adapters/pouchdb/CardRepository";
import { ICardRepository } from "../domain/cards/ICardRepository";
import { IExerciseService } from "../domain/exercise/IExerciseService";
import { ExerciseService } from "../domain/exercise/ExerciseService";

export class Wiring {
    constructor() {
        const portResolver = new PortResolver();
        appDomain.setResolver(portResolver);
        dependencies.setResolver(portResolver);

        // register imports
        portResolver.registerInstance<ICalendarRepository>("ICalendarRepository", () => new CalendarRepository());
        portResolver.registerInstance<ICardRepository>("ICardRepository", () => new CardRepository());

        // register exports
        portResolver.registerInstance<IConfigService>("IConfigService", () => new ConfigService());
        portResolver.registerInstance<ILogService>("ILogService", () => new LogService());

        portResolver.registerInstance<ICalendarService>("ICalendarService", () => new CalendarService());
        portResolver.registerInstance<ICardService>("ICardService", () => new CardService());

        portResolver.registerInstance<IExerciseService>("IExerciseService", () => new ExerciseService());
    }
}

const wiring = new Wiring();
export default wiring;
